import { Schemas } from '~/api/gen'
import { Chip } from '~/components/elements/Chip'
import { buildUrl } from '~/features/shared/search/coordinate/builder/buildUrl'

type Props = {
  popularTags: Schemas.tag[]
}

export const PopularTags: React.FC<Props> = ({ popularTags }) => {
  return (
    <div className="flex flex-col gap-[15px] xl:gap-[14px]">
      <h2 className="text-[18px] font-bold leading-[1.4]">人気のタグ</h2>
      <div className="flex flex-col gap-5">
        <ul className="flex flex-wrap gap-[5px]">
          {popularTags.slice(0, 10).map((popularTag) => (
            <li key={popularTag.id}>
              <Chip
                href={buildUrl({
                  tagIds: [popularTag.id],
                })}
              >
                {`#${popularTag.name}`}
              </Chip>
            </li>
          ))}
        </ul>
        <p className="text-right">
          <a
            href="/keyword/"
            className="text-[13px] font-bold text-blue-400 xl:text-[14px] xl:hover:underline"
          >
            他のトレンドキーワードを見る
          </a>
        </p>
      </div>
    </div>
  )
}
